import { render, staticRenderFns } from "./StockAdjustmentDetailTable.vue?vue&type=template&id=64790f64&scoped=true"
import script from "./StockAdjustmentDetailTable.vue?vue&type=script&lang=ts"
export * from "./StockAdjustmentDetailTable.vue?vue&type=script&lang=ts"
import style0 from "./StockAdjustmentDetailTable.vue?vue&type=style&index=0&id=64790f64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64790f64",
  null
  
)

export default component.exports